import './App.css';
import Home from './services/views/Home';

function App() {
  return <Home />;
}

export default App;
